import React from "react";
const Download = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props?.width || 17}
    height={props?.height || 16}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.66148 9.66667V3M8.66148 9.66667C8.19468 9.66667 7.3225 8.33713 6.99481 8M8.66148 9.66667C9.12828 9.66667 10.0005 8.33713 10.3281 8"
      stroke="#6880CF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0052 11C14.0052 12.6547 13.6599 13 12.0052 13H5.33856C3.6839 13 3.33856 12.6547 3.33856 11"
      stroke="#6880CF"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Download;
